module.exports = __webpack_public_path__ + "img/map-hours-table-lincoln.06532690.png";